import React, { useRef, ReactNode } from 'react';
import { SnackbarProvider } from 'notistack';
import { IconClose } from '../../assets/icons/icon-close';
import { IconToastError, IconToastSuccess, IconToastWarning } from '../../assets/toast-icons';

type CustomSnackbarProviderProps = {
  children: ReactNode;
};

const CustomSnackbarProvider: React.FC<CustomSnackbarProviderProps> = ({ children }) => {
  const closeSnackbar = (key: number | string) => {
    if (notistackRef.current !== null) {
      notistackRef.current.closeSnackbar(key);
    }
  };

  const notistackRef = useRef<SnackbarProvider>(null);

  return (
    <SnackbarProvider
      autoHideDuration={3000}
      ref={notistackRef}
      maxSnack={2}
      preventDuplicate
      iconVariant={{
        success: <IconToastSuccess />,
        error: <IconToastError />,
        info: <IconToastWarning />,
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      action={(key) => (
        <button className="close_toast" onClick={() => closeSnackbar(key)}>
          <IconClose />
        </button>
      )}
    >
      {children}
    </SnackbarProvider>
  );
};

export default CustomSnackbarProvider;
